import { render } from "./RbDialogToolbar.vue?vue&type=template&id=2f071ec5&scoped=true"
import script from "./RbDialogToolbar.vue?vue&type=script&lang=js"
export * from "./RbDialogToolbar.vue?vue&type=script&lang=js"

import "./RbDialogToolbar.vue?vue&type=style&index=0&id=2f071ec5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f071ec5"]])

export default __exports__